import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage, defineMessages } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { emptyObject, emptyArray } from 'ui-components/default-props/empty';
import style from './customer-record-item.module.less';
import DataDrivenLogo from '../../../../../../components/data-driven-logo';

const messages = defineMessages({
  survivingCustomer: {
    description: 'customerRecordContainer.survivingCustomer',
    defaultMessage: 'This will be the surviving customer',
    id: 'RufQ5G',
  },
});

const getCustomerAddress = ({ name, line1, city, state }) => `${name} ${line1} ${city}, ${state}`;

const CustomerRecord = ({
  name = null,
  marketplaces = emptyArray,
  isSurvivor,
  removeCustomer,
  customerId,
  address: addressProp = emptyObject,
}) => {
  const address = getCustomerAddress(addressProp);

  const handleRemoveCustomer = () => {
    removeCustomer(customerId);
  };

  return (
    <div
      className={classnames(style['item-to-merge'], {
        [style['survivor-item']]: isSurvivor,
      })}
    >
      <div className={style['customer-item']}>
        {marketplaces &&
          marketplaces.map((id) => {
            return (
              <span key={id}>
                <div className={style['logo-wrapper']}>
                  <DataDrivenLogo className={style['store-icon']} logoType='icon' marketplaceId={Number.parseInt(id, 10)} />
                </div>
              </span>
            );
          })}
        <strong>
          <span>
            {name} {address}
          </span>
        </strong>
        <Button buttonSize='normal' onClick={handleRemoveCustomer} theme='unstyled'>
          <FontAwesomeIcon className={style.xmark} icon={faXmark} />
        </Button>
      </div>
      {isSurvivor && (
        <div className={style['surviving-item-message']}>
          <FormattedMessage {...messages.survivingCustomer} />
        </div>
      )}
    </div>
  );
};

CustomerRecord.propTypes = {
  marketplaces: PropTypes.arrayOf(PropTypes.string),
  name: PropTypes.string,
  address: PropTypes.object,
  isSurvivor: PropTypes.bool.isRequired,
  removeCustomer: PropTypes.func.isRequired,
  customerId: PropTypes.string.isRequired,
};

export default CustomerRecord;
